import { IAttribute, IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { LinkedService } from 'app/model/linkedservice/linkedservice';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';

export const BITBUCKET_APP_MODEL_VERSION = '1.0';

@Metamodel.model({
    name: 'Bitbucket',
    display: []
})
export class BitbucketLinkedService extends LinkedService {
    public static readonly MODEL: IModel;
    public static readonly HOST: IAttribute;
    public static readonly ACCESS_TOKEN: IAttribute;

    @Metamodel.attribute({
        display: stringResources.DriverVersion
    })
    public version: string = BITBUCKET_APP_MODEL_VERSION;

    @Metamodel.attribute({
        display: stringResources.ModelName_Host,
        association: 'HOST',
        templatable: true
    })
    public host?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AccessToken,
        association: 'ACCESS_TOKEN',
        templatable: true,
        accepts: ['String'],
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public accessToken?: string | AzureKeyVault;
}
